import { Injectable } from '@angular/core';
import { AvisInitialTypeLight } from '../../models/AvisInitialTypeLight';

@Injectable({
  providedIn: 'root',
})
export class AvisInitialService {
  constructor() {}

  public getAvisInitial(controls: any): AvisInitialTypeLight {
    const avisInitial = new AvisInitialTypeLight();
    avisInitial.idWeb = controls.get('_SepSep_Rectificatif_SepSep_AvisInitial_SepSep_AvisInitialType_SepAtt_idWeb');
    const datePublication =
      '_SepSep_Rectificatif_SepSep_AvisInitial_SepSep_AvisInitialType_SepAtt_datePublication';
    avisInitial.datePublication =
      controls.get(datePublication) +
      controls.get(datePublication + '_timestamp');

    return avisInitial;
  }
}
